import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { DEAL_BUILDER_QUERY_PARAM_PROGRESS, DEAL_BUILDER_QUERY_PARAM_STEP } from '../constants';
import { DealBuilderStep } from '../types';

export type GoToDealBuilderStep = (step: DealBuilderStep, extraParams?: Record<string, string>) => void;

// Navigates from anywhere (e.g. the General tab) into the Deal Builder tab at a given step,
// forcing that step to be unlocked by setting progress to the same value
export const useGoToDealBuilderStep = (): GoToDealBuilderStep => {
  const { push } = useHistory();
  const location = useLocation();

  return useCallback(
    (step: DealBuilderStep, extraParams?: Record<string, string>) => {
      const params = new URLSearchParams(location.search);
      params.set(DEAL_BUILDER_QUERY_PARAM_STEP, step);
      params.set(DEAL_BUILDER_QUERY_PARAM_PROGRESS, step);
      Object.entries(extraParams ?? {}).forEach(([key, value]) => params.set(key, value));
      push({ pathname: location.pathname, hash: '#dealBuilder', search: params.toString() });
    },
    [location, push]
  );
};
